import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { searchVenues } from 'apis/restaurant-api/merchant-admin/venue-search/api';

import { isMerchantResult, isVenueResult } from '../utils';

export const useMerchantSearch = (searchString: string, isEnabled: boolean) => {
  const {
    data: searchResults = [],
    isFetching,
    isError,
  } = useQuery(
    ['/v1/merchant-admin/search', searchString],
    () => {
      return searchVenues(searchString);
    },
    {
      enabled: isEnabled,
    },
  );

  const matchingMerchants = useMemo(() => {
    return searchResults.length ? searchResults.filter(isMerchantResult).map(result => result.value) : [];
  }, [searchResults]);

  const matchingVenues = useMemo(() => {
    return searchResults.length ? searchResults.filter(isVenueResult).map(result => result.value) : [];
  }, [searchResults]);

  return {
    data: {
      merchants: matchingMerchants,
      venues: matchingVenues,
    },
    isLoading: isFetching,
    isError,
  };
};
